import API_BASE_URL from "./config";

export const createNewSession = async ({ baseUrl, authToken }) => {
  const response = await fetch(`${baseUrl ?? API_BASE_URL}/liveness/session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    throw new Error("Failed to create session");
  }

  const data = await response.json();
  return data;
};

export const getSessionResult = async ({ baseUrl, sessionId, authToken }) => {
  const response = await fetch(
    `${baseUrl ?? API_BASE_URL}/liveness/session?sessionId=${sessionId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to get session result");
  }

  const data = await response.json();
  return data;
};
